

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface MedicineManufacturersParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface MedicineManufacturers {
    id?: number;
    code: string;
    name:string;
    
  parameters?: MedicineManufacturersParameter[];
  links?: any;
}

export abstract class MedicineManufacturersData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<MedicineManufacturers[]>;
  abstract create(url: string,data: MedicineManufacturers): Observable<any>;
  abstract update(url: string,data: MedicineManufacturers): Observable<any>;
  abstract delete(url: string): Observable<any>;
   abstract searchList(url:string,data:any): Observable<any>;
   //uploadData
   
  abstract postData(url: string,data: any[]): Observable<any>;
}